module.exports = __webpack_public_path__ + "static/media/95.36893cce.jpg";